import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { AccountRolesRouter } from "./Router";

export function AccountRolesContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <AccountRolesRouter />
    </ThemeProvider>
  );
}
